import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3e3ea22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-detail" }
const _hoisted_2 = { class: "notice-detail__1" }
const _hoisted_3 = { class: "notice-detail__2" }
const _hoisted_4 = { class: "notice-detail__3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    ref: "dialogRefs",
    title: _ctx.title,
    width: _ctx.width,
    "custom-class": _ctx.customClass,
    fullscreen: _ctx.fullscreen,
    center: _ctx.center,
    "destroy-on-close": _ctx.destroyOnClose,
    "append-to-body": _ctx.appendToBody,
    "show-close": _ctx.showClose,
    "close-on-click-modal": _ctx.closeOnClickModal,
    "close-on-press-escape": _ctx.closeOnPressEscape,
    modelValue: _ctx.visibleRef,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleRef) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formData.topic), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.momentFormat(_ctx.formData.gmtCreate, "YYYY/MM/DD HH:mm:ss")), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formData.content), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "width", "custom-class", "fullscreen", "center", "destroy-on-close", "append-to-body", "show-close", "close-on-click-modal", "close-on-press-escape", "modelValue"]))
}